var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-toggle-list__panel" }, [
    _c("div", { staticClass: "c-toggle-list__inner" }, [
      _c("div", { staticClass: "c-toggle-list__panel-content" }, [
        _vm.icon
          ? _c("img", {
              staticClass: "c-toggle-list__panel-icon",
              attrs: { src: _vm.icon, alt: "" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h3", { staticClass: "c-toggle-list__title" }, [
          _vm._v(_vm._s(_vm.title))
        ])
      ]),
      _vm._v(" "),
      this.configurable
        ? _c(
            "label",
            {
              staticClass: "c-toggle-list__toggle",
              attrs: { for: _vm.title, "aria-label": _vm.title }
            },
            [
              _c("input", {
                attrs: { id: _vm.title, type: "checkbox" },
                domProps: { checked: _vm.state },
                on: { click: _vm.buttonState }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "c-toggle-list__slider" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-225647d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-225647d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/layered-map/MapTogglePanel.vue
// module id = 659
// module chunks = 0